<template>
  <ion-button
    v-if="route.name !== 'about'"
    v-tooltip.left="$t('base.about')"
    :aria-label="$t('base.about')"
    :disabled
    router-link="/about"
    fill="clear"
    color="primary"
  >
    <ion-icon slot="icon-only" :icon="informationOutline" />
  </ion-button>

  <ion-button
    v-if="route.name !== 'settings'"
    v-tooltip.left="$t('base.settings')"
    :aria-label="$t('base.settings')"
    :disabled
    router-link="/settings"
    fill="clear"
    color="primary"
  >
    <ion-icon slot="icon-only" :icon="settingsOutline" />
  </ion-button>
</template>

<script setup lang="ts">
// What a signed-out visitor can reach from any page: About, and Settings for
// the language and appearance. Each is left out on its own page.
import { IonButton, IonIcon } from '@ionic/vue';
import { informationOutline, settingsOutline } from 'ionicons/icons';
import { useRoute } from 'vue-router';

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false });

const route = useRoute();
</script>
